import { kea } from "kea";

import api, { apifileupload } from '../utils/api';

export const rkeylogic = kea({
	actions: {
		fetch: (query) => ({ query }),

		set: (report) => ({ report }),
		setOne: (trip) => ({ trip }),
		setQuery: (query) => ({ query }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		trips: [[], {
			set: (_, { report }) => [...report.events],
			setOne: (state, { trip }) => state.map((s) => s._id === trip._id ? trip : s),
		}],
		vehicle: [null, {
			set: (_, { report }) => report.vehicle,
		}],
		query: [null, {
			setQuery: (_, { query }) => query,
		}],
		loading: [false, {
			fetch: () => true,

			set: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			set: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetch: async ({ query }, breakpoint) => {
			await breakpoint(300);
			let url = '/report/key';
			let res;
			actions.setQuery(query);
			try {
				res = await api({ url, method: 'post', body: query });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				if (json.payload.events.length) {
					actions.set(json.payload);
					if (!json.payload.events.length) actions.setSuccess('Report fetched but is empty');
					else if (json.payload.events.length >= 10000) actions.setSuccess('Report fetched but limited to 10,000 rows.');
					else actions.setSuccess('Report Fetched.');
				} else actions.setSuccess('No Key events reported')
			} else actions.setError(json.error);
		}
	})
});

export const rsummarylogic = kea({
	actions: {
		fetch: (query) => ({ query }),

		set: (report) => ({ report }),
		setQuery: (query) => ({ query }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		report: [[], {
			set: (_, { report }) => report,
		}],
		query: [null, {
			setQuery: (_, { query }) => query,
		}],
		loading: [false, {
			fetch: () => true,

			set: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			set: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetch: async ({ query }, breakpoint) => {
			await breakpoint(300);
			let url = '/report/summary';
			let res;
			actions.setQuery(query);
			try {
				res = await api({ url, method: 'post', body: query });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.set(json.payload);
				actions.setSuccess('Report Fetched.');
			} else actions.setError(json.error);
		}
	})
});

export const ralertlogic = kea({
	actions: {
		fetch: (query) => ({ query }),

		set: (report) => ({ report }),
		setQuery: (query) => ({ query }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		report: [[], {
			set: (_, { report }) => [...report.events],
		}],
		alert: [null, {
			set: (_, { report }) => report.alert,
		}],
		query: [null, {
			setQuery: (_, { query }) => query,
		}],
		loading: [false, {
			fetch: () => true,

			set: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			set: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetch: async ({ query }, breakpoint) => {
			await breakpoint(300);
			let url = '/report/alert';
			let res;
			actions.setQuery(query);
			try {
				res = await api({ url, method: 'post', body: query });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.set(json.payload);
				if (!json.payload.events.length) actions.setSuccess('Report fetched but is empty');
				else if (json.payload.events.length >= 10000) actions.setSuccess('Report fetched but limited to 10,000 rows.');
				else actions.setSuccess('Report Fetched.');
			} else actions.setError(json.error);
		}
	})
});

export const rgeofencelogic = kea({
	actions: {
		fetch: (query) => ({ query }),

		set: (report) => ({ report }),
		setQuery: (query) => ({ query }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		report: [[], {
			set: (_, { report }) => [...report.events],
		}],
		geofence: [null, {
			set: (_, { report }) => report.geofence,
		}],
		query: [null, {
			setQuery: (_, { query }) => query,
		}],
		loading: [false, {
			fetch: () => true,

			set: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			set: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetch: async ({ query }, breakpoint) => {
			await breakpoint(300);
			let url = '/report/geofence';
			let res;
			actions.setQuery(query);
			try {
				res = await api({ url, method: 'post', body: query });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.set(json.payload);
				if (!json.payload.events.length) actions.setSuccess('Report fetched but is empty');
				else if (json.payload.events.length >= 10000) actions.setSuccess('Report fetched but limited to 10,000 rows.');
				else actions.setSuccess('Report Fetched.');
			} else actions.setError(json.error);
		}
	})
});

export const rmovementlogic = kea({
	actions: {
		fetch: (query) => ({ query }),

		set: (report) => ({ report }),
		setOne: (trip) => ({ trip }),
		setQuery: (query) => ({ query }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		trips: [[], {
			set: (_, { report }) => [...report.events],
			setOne: (state, { trip }) => state.map((s) => s._id === trip._id ? trip : s),
		}],
		vehicle: [null, {
			set: (_, { report }) => report.vehicle,
		}],
		query: [null, {
			setQuery: (_, { query }) => query,
		}],
		loading: [false, {
			fetch: () => true,

			set: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			set: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetch: async ({ query }, breakpoint) => {
			await breakpoint(300);
			let url = '/report/ignition';
			let res;
			actions.setQuery(query);
			try {
				res = await api({ url, method: 'post', body: query });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				if (json.payload.events.length) {
					actions.set(json.payload);
					if (!json.payload.events.length) actions.setSuccess('Report fetched but is empty');
					else if (json.payload.events.length >= 10000) actions.setSuccess('Report fetched but limited to 10,000 rows.');
					else actions.setSuccess('Report Fetched.');
				} else actions.setSuccess('No Movement reported')
			} else actions.setError(json.error);
		}
	})
});

export const rstationarylogic = kea({
	actions: {
		fetch: (query) => ({ query }),

		set: (report) => ({ report }),
		setOne: (trip) => ({ trip }),
		setQuery: (query) => ({ query }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		trips: [[], {
			set: (_, { report }) => [...report.events],
			setOne: (state, { trip }) => state.map((s) => s._id === trip._id ? trip : s),
		}],
		vehicle: [null, {
			set: (_, { report }) => report.vehicle,
		}],
		query: [null, {
			setQuery: (_, { query }) => query,
		}],
		loading: [false, {
			fetch: () => true,

			set: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			set: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetch: async ({ query }, breakpoint) => {
			await breakpoint(300);
			let url = '/report/stationary';
			let res;
			actions.setQuery(query);
			try {
				res = await api({ url, method: 'post', body: query });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.set(json.payload);
				if (!json.payload.events.length) actions.setSuccess('Report fetched but is empty');
				else if (json.payload.events.length >= 10000) actions.setSuccess('Report fetched but limited to 10,000 rows.');
				else actions.setSuccess('Report Fetched.');
			} else actions.setError(json.error);
		}
	})
});

export const rnotificationlogic = kea({
	actions: {
		fetch: (query) => ({ query }),

		set: (report) => ({ report }),
		setQuery: (query) => ({ query }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		report: [[], {
			set: (_, { report }) => [...report.events],
		}],
		vehicle: [null, {
			set: (_, { report }) => report.vehicle,
		}],
		query: [null, {
			setQuery: (_, { query }) => query,
		}],
		loading: [false, {
			fetch: () => true,

			set: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			set: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetch: async ({ query }, breakpoint) => {
			await breakpoint(300);
			let url = '/report/notification';
			let res;
			actions.setQuery(query);
			try {
				res = await api({ url, method: 'post', body: query });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.set(json.payload);
				if (!json.payload.events.length) actions.setSuccess('Report fetched but is empty');
				else if (json.payload.events.length >= 10000) actions.setSuccess('Report fetched but limited to 10,000 rows.');
				else actions.setSuccess('Report Fetched.');
			} else actions.setError(json.error);
		}
	})
});

export const rbeaconmovementlogic = kea({
	actions: {
		fetch: (query) => ({ query }),

		set: (report) => ({ report }),
		setQuery: (query) => ({ query }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		report: [[], {
			set: (_, { report }) => report,
		}],
		query: [null, {
			setQuery: (_, { query }) => query,
		}],
		loading: [false, {
			fetch: () => true,

			set: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			set: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetch: async ({ query }, breakpoint) => {
			await breakpoint(300);
			let url = '/report/beacon_movement';
			let res;
			actions.setQuery(query);
			try {
				res = await api({ url, method: 'post', body: query });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.set(json.payload);
				actions.setSuccess('Report Fetched.');
			} else actions.setError(json.error);
		}
	})
});

export const rtemperaturelogic = kea({
	actions: {
		fetch: (query) => ({ query }),

		set: (report) => ({ report }),
		setQuery: (query) => ({ query }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		report: [[], {
			set: (_, { report }) => report,
		}],
		query: [null, {
			setQuery: (_, { query }) => query,
		}],
		loading: [false, {
			fetch: () => true,

			set: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			set: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetch: async ({ query }, breakpoint) => {
			await breakpoint(300);
			let url = '/report/temperature';
			let res;
			actions.setQuery(query);
			try {
				res = await api({ url, method: 'post', body: query });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.set(json.payload);
				if (!json.payload.events.length) actions.setSuccess('Report fetched but is empty');
				else actions.setSuccess('Report Fetched.');
			} else actions.setError(json.error);
		}
	})
});

export const rtrackerslogic = kea({
	actions: {
		fetch: (query) => ({ query }),

		set: (report) => ({ report }),
		setQuery: (query) => ({ query }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		report: [[], {
			set: (_, { report }) => report,
		}],
		query: [null, {
			setQuery: (_, { query }) => query,
		}],
		loading: [false, {
			fetch: () => true,

			set: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			set: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetch: async ({ query }, breakpoint) => {
			await breakpoint(300);
			let url = '/report/vehicles';
			let res;
			actions.setQuery(query);
			try {
				res = await api({ url, method: 'post', body: query });
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const json = await res.json();
			if (res.ok) {
				actions.set(json.payload);
				if (!json.payload.length) actions.setSuccess('Report fetched but is empty');
				else actions.setSuccess('Report Fetched.');
			} else actions.setError(json.error);
		}
	})
});


export const rerentlogic = kea({
	actions: {
		fetch: (query) => ({ query }),

		set: (report) => ({ report }),
		setQuery: (query) => ({ query }),
		setError: (error) => ({ error }),
		setSuccess: (success) => ({ success }),
	},
	reducers: {
		report: [[], {
			set: (_, { report }) => report,
		}],
		query: [null, {
			setQuery: (_, { query }) => query,
		}],
		loading: [false, {
			fetch: () => true,

			set: () => false,
			setError: () => false,
			setSuccess: () => false,
		}],
		error: [null, {
			set: () => null,
			setSuccess: () => null,
			setError: (_, { error }) => [error],
		}],
		success: [null, {
			setError: () => null,
			setSuccess: (_, { success }) => [success]
		}]
	},
	listeners: ({ actions }) => ({
		fetch: async ({ query }, breakpoint) => {
			await breakpoint(300);
			const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			let url = '/report/erent?timezone=' + timezone;
			let res;
			actions.setQuery(query);
			try {
				const formData = new FormData();
				formData.append('file', query);

				res = await apifileupload({ url, method: 'post', body: formData });
				if (!res.ok) {
					throw new Error('Failed to get report');
				}
			} catch (error) {
				actions.setError(error.message);
				return;
			}
			const blob = await res.blob();
			const tempurl = window.URL.createObjectURL(blob);
			// Create a temporary anchor element to trigger the download
			const a = document.createElement('a');
			a.href = tempurl;
			a.download = 'output.xlsx';  // Change to your desired file name
			document.body.appendChild(a);
			a.click();

			// Clean up
			window.URL.revokeObjectURL(tempurl);
			document.body.removeChild(a);
		}
	})
});